import styled, { keyframes } from "styled-components";
import Landing from "../../assets/icons/LandingPage.png";
// import { colors } from "../../theme/color";
import fipayFonts from "../../theme/index";

const slideInFromBottom = keyframes`
  from {
    transform: translateY(80%);
  }
  to {
    transform: translateY(0);
  }
`;

const flipXAnimation = keyframes`
  0% {
    opacity: 1;
    transform: rotateX(100deg);
  }
  100% {
    opacity: 1;
    transform: rotateX(420deg);
  }
`;
export const HeroContainer = styled.div`

     width: 90%;
     display: flex;
     flex-direction: row;
     justify-content: space-between;
     margin: 0;
     padding-top:40px;
     padding-bottom:120px;
    

  @media screen and (min-width: 0px) and (max-width: 766px){
    width: 90%;
    display: grid;
    text-align: left;
    padding-top:0px;
    
    
  }
   @media screen and (min-width: 767px) and (max-width: 1025px) {
    
      display: grid;
    }
 
  
}

.second_div {
  width:100px;
 display:flex;
 position:relative;
 right:170px;
 text-align: center;
 border-radius: 10px;
 transition: transform 1s ease-in-out;
 .shifted {

  @media screen and (min-width: 0px) and (max-width: 766px){
    transform: translateX(-60%); 
    
  }
}

 @media screen and (min-width: 0px) and (max-width: 766px){
  width:80px;
  left: 60px;
  top: 10px;
}
@media screen and (min-width: 767px) and (max-width: 1024px){
  margin-bottom: 10px;
}

p{
  padding:10px;
  border-radius: 10px;
  width:300px;
  font-family: GT Walsheim Pro;
  font-size: ${fipayFonts.fipayFonts.fontSize.footer2};
  opacity: 1;
  line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
  

 @media screen and (min-width: 0px) and (max-width: 766px){
  font-size: ${fipayFonts.fipayFonts.fontSize.footer2};

}
}
}


.third_div.shifted {
  transform: translateX(-150%); 
  @media screen and (min-width: 0px) and (max-width: 766px){
    transform: translateX(-80%);
  }
}



    div h2{
        font-family: GT Walsheim Pro;
        font-size: ${fipayFonts.fipayFonts.fontSize.display1};
        line-height: 70px;
        letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
        color: #09005B;
        @media screen and (max-width: 766px) {
          font-size: ${fipayFonts.fipayFonts.fontSize.heading2};
          line-height: 40px;
        }

    }


    .Hero_img{
      display:flex;
      flex-direction: row;
      align-items:center;
      justify-content:center;
      gap: 0;
      @media screen and (min-width: 0px) and (max-width: 766px){
        // border: 1px solid red;
        margin-right: 10%;
        margin-left: 8%;
      }
      

      
   
      
`;

export const Container = styled.div`
  background-image: url("/assets/icons/LandingPage.jpg");
  display: flex;
  align-items: center;
  background-size: cover;
  flex-direction: column;
`;

export const EarthRound = styled.div`
  width: 40%;
  height: 400px;
  display: flex;
  align-items: center;
  margin-top: 20px;

  //animation: ${slideInFromBottom} 1.5s ease-in-out;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    width: 100%;
    justify-content: space-between;
    height: 300px;
    display: none;
    .first_Img {
      width: 20px;
    }
  }
  .curve {
    margin-left: 70px;

    @media screen and (min-width: 0px) and (max-width: 766px) {
      width: 80px;
      height: 140px;
      left: 15px;
      display: none;
    }
  }
  perspective: 500px;
  .layer {
    position: relative;
    right: 95px;
    animation: rotateAnimation 5s infinite linear;
    transform: rotate(-20deg);
    perspective-origin: 50%;
    transform-style: preserve-3d;

    @keyframes rotateAnimation {
      from {
        transform: rotateY(0deg);
      }
      to {
        transform: rotateZ(360deg);
      }
    }
    @media screen and (min-width: 0px) and (max-width: 766px) {
      width: 160px;
      height: 160px;
      left: 5px;
      animation: rotateAnimation 5s infinite linear;
    }
    // @media screen and (min-width: 767px) and (max-width: 1024px){
    //   right: 10px;
    // }
  }
`;
export const FixtureDiv = styled.div`
  height: 400px;

  display: flex;
  justify-content: center;
  // position:relative;
  left: 35px;
  flex-direction: column;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    left: 0px;
    width: 70%;
  }
  .first_div {
    width: 150px;
    height: auto;
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    font-size: ${fipayFonts.fipayFonts.fontSize.body3};
    font-family: GT Walsheim Pro;
    text-align: center;
    transition: transform 1.5s ease-in-out;
    display: flex;

    align-items: center;
    justify-content: center;
    position: relative;
    right: 125px;
    bottom: 70px;
    @media screen and (min-width: 0px) and (max-width: 766px) {
      width: 80px;
      height: 20px;
      bottom: 15px;
    }
  }
  .first_div.shifted {
    transform: translateX(-150%); /* Adjust the value based on your layout */
    @media screen and (min-width: 0px) and (max-width: 766px) {
      transform: translateX(-80%);
    }
  }

  .middle_div {
    width: 150px;
    height: 50px;
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    font-size: ${fipayFonts.fipayFonts.fontSize.body3};
    font-family: GT Walsheim Pro;
    text-align: center;
    transition: transform 1.5s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    right: 190px;
    bottom: 10px;
    @media screen and (min-width: 0px) and (max-width: 766px) {
      bottom: 5px;
    }
  }

  .middle_div.shifted {
    transform: translateX(-150%); /* Adjust the value based on your layout */
    @media screen and (min-width: 0px) and (max-width: 766px) {
      transform: translateX(-80%);
    }
  }
  .third_div {
    width: 160px;
    transition: transform 1.5s ease-in-out;
    /* font-weight: 400; */
    font-size: ${fipayFonts.fipayFonts.fontSize.body3};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    display: flex;
    position: relative;
    right: 145px;
    top: 65px;
    text-align: center;
    @media screen and (min-width: 0px) and (max-width: 766px) {
      top: 35px;
      width: 100px;
    }
  }

  .text-hint {
    background: white;
    padding: 10px;
    border-radius: 10px;
    width: 300px;
    font-family: GT Walsheim Pro;
    font-size: ${fipayFonts.fipayFonts.fontSize.body3};
    opacity: 1;
    line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
    @media screen and (min-width: 0px) and (max-width: 866px) {
      font-size: ${fipayFonts.fipayFonts.fontSize.footer3};
      width: 150px;
      margin-right: -12px;
    }
  }
  .middle-hint {
    background: linear-gradient(
      106.94deg,
      #ffffff 2.35%,
      #ffffea 40.43%,
      #dcebff 95.94%
    );
    padding: 10px;
    border-radius: 10px;
    width: 300px;
    font-family: GT Walsheim Pro;
    font-size: ${fipayFonts.fipayFonts.fontSize.body3};
    opacity: 1;
    line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
    @media screen and (min-width: 0px) and (max-width: 766px) {
      width: 60px;
      margin-right: -8px;
      margin-top: 70px;
      font-size: ${fipayFonts.fipayFonts.fontSize.footer3};
    }
  }

  .last-hint {
    background: white;
    padding: 10px;
    border-radius: 10px;
    width: 300px;
    font-family: GT Walsheim Pro;
    /* font-size: 14px; */
    font-size: ${fipayFonts.fipayFonts.fontSize.body3};
    opacity: 1;
    /* line-height: 24px; */
    line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
    @media screen and (min-width: 0px) and (max-width: 766px) {
      width: 80px;
      font-size: ${fipayFonts.fipayFonts.fontSize.footer3};
      margin-right: 5px;
      margin-top: 25px;
    }
  }
  .inner-gra1 {
    position: absolute;
    margin-bottom: 270px;
    margin-left: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (min-width: 0px) and (max-width: 766px) {
      right: 10px;
      width: 70%;
      margin-bottom: 170px;
    }
  }
  .inner-gra2 {
    position: absolute;
    margin-bottom: 20px;
    margin-left: 170px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (min-width: 0px) and (max-width: 766px) {
      margin-left: 135px;
    }
  }
  .inner-gra3 {
    position: absolute;
    margin-top: 250px;
    margin-left: 240px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (min-width: 0px) and (max-width: 766px) {
      margin-top: 150px;
      margin-left: 175px;
    }
  }
`;

export const HeroContent = styled.div`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const HeroTitle = styled.h2`
  width: 700px;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    width: 370px;
  }
`;

export const HeroSmallScreen = styled.h2`
  display: none;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    h2 {
      font-family: GT Walsheim Pro;
      /* font-size: 30px; */
      font-size: ${fipayFonts.fipayFonts.fontSize.heading2};
      /* font-weight: 700; */
      font-size: ${fipayFonts.fipayFonts.fontWeight.bold};
      line-height: 34px;
      /* letter-spacing: 0.5px; */
      letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
      background: #09005b;
      width: 326px;
    }
  }
`;

export const HeroParagraph = styled.p`
  font-family: GT Walsheim Pro;
  /* font-size: 18px; */
  font-size: ${fipayFonts.fipayFonts.fontSize.body1};
  /* font-weight: 400; */
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  /* letter-spacing: 0.02em; */
  color: #5e5e5e;
  line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};
  /* line-height: 32px; */
  /* margin-top: -15px; */
  width: 550px;
  margin-bottom: 32px;
  & > .flipX {
    animation: 1s ${flipXAnimation} ease;
    margin-bottom: -25px; /* Adjust the value based on your preference */
  }

  @media screen and (min-width: 0px) and (max-width: 766px) {
    margin-top: 10px;
    /* font-size: 16px; */
    font-size: ${fipayFonts.fipayFonts.fontSize.body2};
    /* line-height: 24px; */
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    width: 295px;
  }
`;

export const HeroText = styled.p`
  /* ... your existing styles ... */

  &.flipX {
    animation: 1s ${flipXAnimation} ease;
  }
`;

export const StyledHeroTitle = styled.h2.attrs({ className: "flipX" })`
  animation: 1s ${flipXAnimation} ease;
  /* margin-bottom: -50px; */
`;
